import { render, staticRenderFns } from "./TypeMenu.vue?vue&type=template&id=c1db8c5c&scoped=true"
import script from "./TypeMenu.vue?vue&type=script&lang=js"
export * from "./TypeMenu.vue?vue&type=script&lang=js"
import style0 from "./TypeMenu.vue?vue&type=style&index=0&id=c1db8c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1db8c5c",
  null
  
)

export default component.exports